import adid1 from '../img/shoes/adidas/adi1.png';
import Pg1 from '../img/shoes/nike/pg1.png';
import Curry1 from '../img/shoes/underarmour/curry9.png';
import Vb1 from '../img/shoes/othersports/vb1.png';

export const heroData = [
  {
    id: 1,
    name: "Don Issue #3",
    decp: "Adidas Donavan",
    price: "4500",
    imageSrc: adid1,
  },
  {
    id: 2,
    name: "PG Playstation",
    decp: "Nike Paul George",
    price: "3500",
    imageSrc: Pg1,
  },
  {
    id: 3,
    name: "Curry Flow 9",
    decp: "Under Armour Unisex",
    price: "7495",
    imageSrc: Curry1,
  },
  {
    id: 4,
    name: "Flow BreakThru",
    decp: "Under Armour",
    price: "5495",
    imageSrc: Vb1,
  },
];

export const categories = [
  {
    id: 1,
    name: "Under Armour",
    urlParamName: "under armour",
  },
  {
    id: 2,
    name: "Nike",
    urlParamName: "nike",
  },
  {
    id: 3,
    name: "Adidas",
    urlParamName: "adidas",
  },
  {
    id: 4,
    name: "Anta",
    urlParamName: "anta",
  },
  {
    id: 5,
    name: "Air Jordan",
    urlParamName: "air jordan",
  },
  {
    id: 6,
    name: "Collectors Choice",
    urlParamName: "collectors choice",
  },

  {
    id: 7,
    name: "Other Sports",
    urlParamName: "other sports",
  },
];